/** Explicit cash interface vocabulary. User content and document references are
 * not dictionary keys. Shared application translations fill common controls. */
export const cashArabic: Record<string, string> = Object.fromEntries(`
Branch cash|نقدية الفروع
Employee advance|سلفة موظف
Employee advance repayment|سداد سلفة موظف
Receipt-line value/quantity, including any portion owed; not a second cash expense.|قيمة وكمية بنود الإيصال، بما فيها الجزء المستحق؛ وليست مصروفًا نقديًا ثانيًا.
counted|معدود
difference|الفرق
category_code|كود الفئة
category_en|اسم الفئة بالإنجليزية
category_ar|اسم الفئة بالعربية
item_code|كود البند
item_en|اسم البند بالإنجليزية
item_ar|اسم البند بالعربية
usual_up_to|الحد المعتاد
Expense setup|إعداد المصروفات
Missing columns|أعمدة ناقصة
Created|أُنشئ
Renamed|تغير الاسم
Restored|استُعيد
Code changed|تغير الكود
Category icon changed|تغيرت أيقونة الفئة
Note required|الملاحظة مطلوبة
Note optional|الملاحظة اختيارية
Updated|حُدّث
Unknown user|مستخدم غير معروف
Unknown date|تاريخ غير معروف
category|فئة
reason|السبب
usual up to|الحد المعتاد
Unspecified|غير محدد
stock|مخزون
expenses|مصروفات
held|محتفظ به
counts|فروق الجرد
spent|مصروف
taking|سلفة
float|عهدة
open|مفتوح
owed|مستحق
received|مستلم
short|عجز
over|زيادة
A holder and purchase purpose are required.|يجب تحديد حامل النقدية والغرض من الشراء.
A named person holds cash until the receipt or full return|تبقى النقدية مع الشخص المحدد حتى تقديم الإيصال أو إرجاعها بالكامل
A photo is required before recording this payment or final invoice.|تلزم صورة قبل تسجيل الدفعة أو الفاتورة النهائية.
A receipt photo is required before posting the expense.|تلزم صورة الإيصال قبل ترحيل المصروف.
A supplier gave cash back|أعاد مورد نقدية
A wallet|محفظة
Actual spent / owed|المصروف الفعلي / المستحق
Branch / reference|الفرع / المرجع
Category / code / line item · English / العربية|الفئة / الكود / البند
Check that dates and amount limits are valid.|تحقق من صحة التواريخ وحدود المبالغ.
Counted total applies to the complete selected branch/collector group, not just this handover.|ينطبق الإجمالي المعدود على مجموعة الفرع والمحصّل المحددة بالكامل، وليس هذا التسليم فقط.
Date unavailable|التاريخ غير متاح
Day / branch|اليوم / الفرع
Different amount|مبلغ مختلف
Enter the counted cash|أدخل النقدية المعدودة
Finance / Bulk setup|الإدارة المالية / إعداد جماعي
Financials / Branch cash|المالية / نقدية الفروع
Held / owed|المحتفظ به / المستحق
Holder / branch|حامل النقدية / الفرع
Job / branch|العمل / الفرع
Line item / ID|البند / المعرّف
Line item / holder / note|البند / حامل النقدية / الملاحظة
Number of spending/reversal events, not their monetary sum.|عدد حركات الصرف والعكس، وليس مجموعها النقدي.
Count of positive original spending events exceeding their current branch/default usual amount. Signed reversal events are excluded; this is not a net-count measure.|عدد حركات الصرف الأصلية الموجبة التي تتجاوز الحد المعتاد الحالي للفرع أو الافتراضي. تُستبعد حركات العكس؛ هذا ليس صافي عدد الحركات.
Opened / accepted|فُتح / قُبل
PO number, supplier, date or total|رقم أمر الشراء أو المورد أو التاريخ أو الإجمالي
Person / float / branch|الشخص / العهدة / الفرع
Quantity / unit / original rate|الكمية / الوحدة / السعر الأصلي
Reason / note|السبب / الملاحظة
Receipt / entry|الإيصال / القيد
Recorded by branch staff|سجله موظفو الفرع
Reference / branch|المرجع / الفرع
Result / reason|النتيجة / السبب
Select person|اختر شخصًا
Sign in to a workspace before saving.|سجّل الدخول إلى مساحة عمل قبل الحفظ.
Source / return reference|مرجع المصدر / الإرجاع
System / opening|النظام / الافتتاحي
Taking / purpose|السلفة / الغرض
The original stays visible. Linked change/extra entries are reversed and the taking reopens. Confirm the related physical cash has been restored.|يبقى الأصل ظاهرًا. تُعكس قيود الباقي والزيادة المرتبطة وتُفتح السلفة مجددًا. أكد استعادة النقدية الفعلية المرتبطة.
Types|الأنواع
View categories|عرض الفئات
all branches|جميع الفروع
by branch|حسب الفرع
codes are empty in the file.|أكواد فارغة في الملف.
codes generated|أكواد مولدة
entries · evidence total|قيود · إجمالي المستندات
line item|بند مصروف
line items|بنود مصروفات
optional, you can add more later|اختياري، يمكنك إضافة المزيد لاحقًا
records created ·|سجلات أُنشئت ·
rows ready to check|صفوف جاهزة للمراجعة
uploads after saving|تُرفع بعد الحفظ
when you create it|عند إنشائه
will wait for a connection|ستنتظر الاتصال
· 25 entries per page|· 25 قيدًا في الصفحة
· code|· كود
· face amount|· القيمة الاسمية
· line items use|· بنود تستخدم
· not posted|· غير مرحل
· taken|· مسحوب
· uploaded|· مرفوع
✓ matches balance now|✓ يطابق الرصيد الحالي
7 days per page ·|7 أيام في الصفحة ·
KB prepared on this phone ·|كيلوبايت مجهزة على هذا الهاتف ·
0 changes|لا تغييرات
New funding required|التمويل الجديد المطلوب
Clicked total|الإجمالي المختار
Snapshot total|إجمالي اللقطة
of ? payments · paid|من ؟ دفعات · المدفوع
for|لـ
at|في
Branch cash / خزنة الفرع|نقدية الفرع
Overview|نظرة عامة
Cash book|دفتر النقدية
Where it went|صرفنا فين
Daily counts|الجرد اليومي
Cash boxes|الخزن
Collections|التحصيلات
Jobs|الأعمال
Who holds cash|الفلوس مع مين
Things to fix|حاجات محتاجة حل
Insights|التحليلات
Categories & line items|الفئات وبنود المصروفات
Categories &amp; line items|الفئات وبنود المصروفات
My personal floats / عهدتي|عهدتي الشخصية
My personal floats|عهدتي الشخصية
Personal floats|العهد الشخصية
Personal float|عهدة شخصية
Cash box|الخزنة
Branch box|خزنة الفرع
Home branch|الفرع الأساسي
Branch|الفرع
Branches|الفروع
All branches|جميع الفروع
All authorized branches|جميع الفروع المصرح بها
All branches (default)|جميع الفروع (الافتراضي)
Choose branches|اختر الفروع
Choose one or more branches|اختر فرعًا أو أكثر
Loading branches…|جارٍ تحميل الفروع…
Show cash for|عرض نقدية
1 branch|فرع واحد
Clear all|إلغاء تحديد الكل
Choose a branch|اختر فرعًا
Choose a box|اختر خزنة
Pick at least one branch.|اختر فرعًا واحدًا على الأقل.
No boxes were open in these dates.|لا توجد خزن مفتوحة خلال هذه التواريخ.
In the box|في الخزنة
In the box now|في الخزنة الآن
Balance now|الرصيد الحالي
Float|العهدة المستهدفة
Float & top up needed|العهدة والتغذية المطلوبة
Top up needed|التغذية المطلوبة
Of float|من العهدة
Opening|الافتتاحي
Opening balance|الرصيد الافتتاحي
Closing|الختامي
Money in|نقدية داخلة
Money out|نقدية خارجة
Count differences|فروق الجرد
Count difference|فرق الجرد
Signed count differences|فروق الجرد بالإشارة
Now|الآن
Today|اليوم
Yesterday|أمس
This month|هذا الشهر
Last month|الشهر الماضي
Last 7 days|آخر 7 أيام
Last 30 days|آخر 30 يومًا
Last 60 days|آخر 60 يومًا
Last 90 days|آخر 90 يومًا
Since the box opened|منذ فتح الخزنة
Selected dates|التواريخ المحددة
From|من
To|إلى
Date|التاريخ
Date and time|التاريخ والوقت
Day|اليوم
Age|العمر
Age (days)|العمر (بالأيام)
Any age|أي عمر
All types|جميع الأنواع
All statuses|جميع الحالات
All people|جميع الأشخاص
Type|النوع
Type (several)|النوع (متعدد)
Person (several)|الشخص (متعدد)
Direction|الاتجاه
Amount from|المبلغ من
Amount to|المبلغ إلى
Amount|المبلغ
Amount (EGP)|المبلغ (ج.م.)
Amount in EGP|المبلغ بالجنيه المصري
Amount actually spent (EGP)|المبلغ المصروف فعليًا (ج.م.)
Period contribution (EGP)|المساهمة في الفترة (ج.م.)
Contribution (EGP)|المساهمة (ج.م.)
Contribution EGP|المساهمة بالجنيه المصري
Total EGP|الإجمالي بالجنيه المصري
Held EGP|النقدية المحتفظ بها بالجنيه المصري
New entry|قيد جديد
Entry|قيد
Entries|القيود
Entry record|سجل القيد
Cash movement|حركة نقدية
Entry attachment|مرفق القيد
Entry to classify|قيد يحتاج إلى تصنيف
No entries yet|لا توجد قيود بعد
No entries match these filters|لا توجد قيود تطابق هذه المرشحات
No entries for this selection.|لا توجد قيود لهذا الاختيار.
Could not load entries|تعذر تحميل القيود
Loading entries…|جارٍ تحميل القيود…
Try changing the dates or clearing filters.|جرّب تغيير التواريخ أو إلغاء المرشحات.
Shop, receipt, reference, person, note or amount|المحل أو الإيصال أو المرجع أو الشخص أو الملاحظة أو المبلغ
Filters ▾|المرشحات ▾
No posted entries contribute to this amount.|لا توجد قيود مرحلة تساهم في هذا المبلغ.
No entries contribute to this amount under the selected filters.|لا توجد قيود تساهم في هذا المبلغ ضمن المرشحات المحددة.
No contributing items.|لا توجد عناصر مساهمة.
There are no entries behind this number.|لا توجد قيود وراء هذا الرقم.
Back to the list|العودة إلى القائمة
Cash figure changed|تغير الرقم النقدي
Refresh overview|تحديث النظرة العامة
Refresh and recount|تحديث وإعادة الجرد
Refresh for latest actions|تحديث لعرض الإجراءات الحالية
Refresh cash boxes|تحديث الخزن
The figure changed since it was loaded. Refresh before opening its evidence.|تغير الرقم منذ تحميله. حدّث الصفحة قبل فتح مستنداته.
The box changed since this number was loaded. Refresh to see current evidence.|تغيرت الخزنة منذ تحميل الرقم. حدّث لعرض المستندات الحالية.
This overview expired; refresh it for a new snapshot.|انتهت صلاحية هذه النظرة العامة؛ حدّث للحصول على لقطة جديدة.
Snapshot|لقطة البيانات
Snapshot contribution:|المساهمة في اللقطة:
This is the snapshot behind the clicked figure.|هذه لقطة البيانات التي تفسر الرقم الذي اخترته.
These are the items behind the clicked figure. Opening an item shows its record; returning keeps this original list and amount.|هذه عناصر الرقم الذي اخترته. فتح عنصر يعرض سجله، والعودة تحافظ على القائمة والمبلغ الأصليين.
This list|هذه القائمة
Evidence|المستندات المؤيدة
Evidence total:|إجمالي المستندات:
Calculated evidence balance:|الرصيد المحسوب من المستندات:
Box before|الخزنة قبل
Box after|الخزنة بعد
Box balance after|رصيد الخزنة بعد
Box opened|فتح الخزنة
Opened|فُتح
Recorded|مسجل
Posted|مرحل
Pending|معلق
Reversed|معكوس
Reversed / voided|معكوس / ملغى
Reversed by|عكسه
Reversal|عكس قيد
Reason|السبب
Why|لماذا
Who|من
When|متى
What|ماذا
Status|الحالة
Setting|الإعداد
Current user|المستخدم الحالي
Staff name|اسم الموظف
Staff without a login|موظف دون حساب
Branch staff|موظفو الفرع
Typed name · separate taking identity|اسم مدخل · هوية مستقلة للسلفة
Typed staff name · this taking only|اسم موظف مدخل · لهذه السلفة فقط
Unnamed person|شخص دون اسم
Person|الشخص
Holder|حامل النقدية
Choose a person|اختر شخصًا
Choose person|اختر الشخص
Choose an Infrastock user|اختر مستخدمًا في إنفراستوك
Choose a user|اختر مستخدمًا
Infrastock user|مستخدم إنفراستوك
Head office or person|الإدارة أو الشخص
Supplier or person|المورد أو الشخص
Supplier or shop|المورد أو المحل
Supplier name|اسم المورد
Supplier unavailable|المورد غير متاح
Unknown|غير معروف
Unknown status|حالة غير معروفة
Not recorded (legacy)|غير مسجل (سجل قديم)
Not recorded (legacy count)|غير مسجل (جرد قديم)
Not set|غير محدد
Never counted|لم يُجرد من قبل
Not counted|لم يُجرد
Not counted yet|لم يُجرد بعد
No limit|بلا حد
No difference|لا يوجد فرق
Note|ملاحظة
Note (optional)|ملاحظة (اختيارية)
Required|مطلوب
Optional|اختياري
Close|إغلاق
Cancel|إلغاء
Confirm|تأكيد
Done|تم
Save|حفظ
Save changes|حفظ التغييرات
Saving…|جارٍ الحفظ…
Loading…|جارٍ التحميل…
Loading|جارٍ التحميل
Saving|جارٍ الحفظ
Retry|إعادة المحاولة
Retry save|إعادة محاولة الحفظ
Retry same request|إعادة الطلب نفسه
Retry same action|إعادة الإجراء نفسه
Retry same count|إعادة الجرد نفسه
Retry same taking|إعادة السلفة نفسها
Refresh|تحديث
Previous|السابق
Next|التالي
Page|الصفحة
of|من
Of|من
Newer|الأحدث
Older|الأقدم
Newest|الأحدث
Oldest|الأقدم
Action|الإجراء
Actions|الإجراءات
Open|فتح
Show|عرض
Select|اختيار
Search|بحث
All|الكل
Any|أي
Yes|نعم
No|لا
In|داخل
Out|خارج
Net|الصافي
Total|الإجمالي
Summary|الملخص
Contribution|المساهمة
Count|عدد
Final|النهائي
After|بعد
Before|قبل
Expected|المتوقع
Counted|المعدود
Paid|المدفوع
Remaining|المتبقي
Spent|المصروف
Held|المحتفظ به
Owed|مستحق
Over|زيادة
Short|عجز
Difference|الفرق
Quote|عرض السعر
Purpose|الغرض
Name|الاسم
ID|المعرّف
Code|الكود
Check|مراجعة
Error|خطأ
Finance|الإدارة المالية
Bank|البنك
Wallet|المحفظة
Safe|الخزنة المركزية
The safe|الخزنة المركزية
The bank|البنك
The wallet|المحفظة
EGP|ج.م.
Top up from the office|تغذية من الإدارة
Cash from the till|نقدية من درج البيع
Refund from a supplier|مبلغ مسترد من مورد
Other money in|نقدية أخرى داخلة
Expense|مصروف
Paid to supplier|مدفوع للمورد
Advance to a supplier|دفعة مقدمة لمورد
Handed to the office|مسلّم للإدارة
Cash taken|نقدية مسحوبة
Change back|باقي مسترد
Extra paid from box|مبلغ إضافي من الخزنة
Float given|عهدة مسلّمة
Float returned|عهدة مستردة
Cash sent or handed over by head office|نقدية أرسلتها أو سلمتها الإدارة
Moved from today's sales into the box|منقول من مبيعات اليوم إلى الخزنة
Anything else — say what it is|أي شيء آخر — وضّح الغرض
Choose what happened to the cash in the box.|اختر ما حدث لنقدية الخزنة.
Adds cash to the box|يضيف نقدية إلى الخزنة
Takes cash out of the box|يسحب نقدية من الخزنة
Add money in|إضافة نقدية داخلة
Add a short note|أضف ملاحظة قصيرة
Say what this money is for.|وضّح الغرض من هذا المبلغ.
Cash actions require an online connection. Nothing has been queued.|الإجراءات النقدية تتطلب اتصالًا بالإنترنت. لم يُحفظ أي إجراء للإرسال لاحقًا.
Check your connection and try again.|تحقق من الاتصال ثم حاول مرة أخرى.
Enter a positive amount with up to two decimal places.|أدخل مبلغًا موجبًا بحد أقصى منزلتين عشريتين.
Enter a positive amount with at most two decimals.|أدخل مبلغًا موجبًا بحد أقصى منزلتين عشريتين.
Enter an amount with at most two decimals.|أدخل مبلغًا بحد أقصى منزلتين عشريتين.
Enter a nonnegative amount with at most 12 integer digits and two decimals.|أدخل مبلغًا غير سالب بحد أقصى 12 رقمًا صحيحًا ومنزلتين عشريتين.
Use a nonnegative amount with up to two decimal places.|استخدم مبلغًا غير سالب بحد أقصى منزلتين عشريتين.
Use nonnegative amounts with up to two decimal places.|استخدم مبالغ غير سالبة بحد أقصى منزلتين عشريتين.
Could not save this entry. Retry using the same submission key.|تعذر حفظ القيد. أعد المحاولة بنفس مفتاح الإرسال.
To change the entry, close this dialog and start a new one. Retrying will not duplicate this entry.|لتغيير القيد أغلق هذه النافذة وابدأ قيدًا جديدًا. إعادة المحاولة لن تكرر هذا القيد.
Request failed. Please try again.|تعذر تنفيذ الطلب. حاول مرة أخرى.
Unable to complete cash request|تعذر إتمام الطلب النقدي
Could not load this record.|تعذر تحميل هذا السجل.
Could not load this list.|تعذر تحميل هذه القائمة.
Could not load evidence.|تعذر تحميل المستندات.
Could not load filter choices.|تعذر تحميل خيارات المرشحات.
Could not load date totals.|تعذر تحميل إجماليات التواريخ.
Could not load choices.|تعذر تحميل الخيارات.
Could not load Now — retry|تعذر تحميل الأرصدة الحالية — أعد المحاولة
Loading photo…|جارٍ تحميل الصورة…
Photo could not be loaded.|تعذر تحميل الصورة.
Add photo|إضافة صورة
Has photo|توجد صورة
No photo|بلا صورة
Photo|صورة
Photo ready|الصورة جاهزة
Photo uploaded.|تم رفع الصورة.
Photo has not uploaded yet.|لم تُرفع الصورة بعد.
No photos attached|لا توجد صور مرفقة
No receipt photo is attached.|لا توجد صورة إيصال مرفقة.
Photo of the receipt|صورة الإيصال
Receipt photo|صورة الإيصال
Receipt photo (required)|صورة الإيصال (مطلوبة)
Take photo|التقاط صورة
From gallery|من معرض الصور
Choose uploaded receipt photo|اختر صورة إيصال مرفوعة
Receipt photo upload failed|تعذر رفع صورة الإيصال
Receipt photo uploaded.|تم رفع صورة الإيصال.
Retry photo upload|إعادة رفع الصورة
Photo upload failed.|تعذر رفع الصورة.
Photo upload failed. Retry when online.|تعذر رفع الصورة. أعد المحاولة عند الاتصال بالإنترنت.
Photo upload returned no evidence ID.|لم تُرجع عملية الرفع معرّفًا للصورة.
Shrinking photo on this phone…|جارٍ تصغير الصورة على هذا الهاتف…
Could not prepare photo.|تعذر تجهيز الصورة.
Photo saved on this phone; it will send when you are online.|حُفظت الصورة على هذا الهاتف وستُرسل عند الاتصال بالإنترنت.
Entry saved without an uploaded photo. The photo is waiting on this phone for a connection.|حُفظ القيد دون صورة مرفوعة. الصورة محفوظة على هذا الهاتف وتنتظر الاتصال.
Sign in to upload a photo.|سجّل الدخول لرفع صورة.
Record an expense|تسجيل مصروف
Save expense|حفظ المصروف
What was it for?|فيم صُرف؟
What is it for?|ما الغرض؟
What was it for? Who was paid?|فيم صُرف؟ ولمن دُفع؟
How much?|كم المبلغ؟
What branches choose from when they record a cash expense|ما يختاره الفرع عند تسجيل مصروف نقدي
Search line items and categories|ابحث عن بنود المصروفات والفئات
Search categories and line items|ابحث عن الفئات وبنود المصروفات
Recently used|المستخدم حديثًا
Or pick a category|أو اختر فئة
It's not in the list · Record as To classify|غير موجود بالقائمة · سجل للمراجعة والتصنيف
To classify|يحتاج إلى تصنيف
Finance · To classify|الإدارة المالية · يحتاج إلى تصنيف
Finance will classify this later. Explain it in the note.|ستصنف الإدارة المالية المصروف لاحقًا. وضّحه في الملاحظة.
Classify expense|تصنيف المصروف
Save classification|حفظ التصنيف
Expense classified.|تم تصنيف المصروف.
Could not classify this entry.|تعذر تصنيف هذا القيد.
Expense note|ملاحظة المصروف
Optional: what was fixed, who was paid|اختياري: ما الذي أُصلح ولمن دُفع
Choose what this was for, enter a valid amount and any required note.|اختر الغرض، وأدخل مبلغًا صحيحًا وأي ملاحظة مطلوبة.
Buying food or packaging? Use Pay a supplier receipt instead, so it goes into stock.|تشتري طعامًا أو مواد تغليف؟ استخدم دفع إيصال مورد بدلًا من ذلك لتسجيله في المخزون.
Above usual|أعلى من المعتاد
Above the usual|أعلى من المعتاد
Above current usual|أعلى من المعتاد حاليًا
Above usual (|أعلى من المعتاد (
Current usual up to|الحد المعتاد الحالي
Compared with the branch's current usual amount; this may have changed since the expense was recorded.|المقارنة بالحد المعتاد الحالي للفرع، وقد يكون تغير منذ تسجيل المصروف.
Compared with the branch’s current usual amount; it may have changed since this expense was recorded.|المقارنة بالحد المعتاد الحالي للفرع، وقد يكون تغير منذ تسجيل المصروف.
Expense saved without a photo. Add one from Needs attention or its record.|حُفظ المصروف دون صورة. أضف صورة من قائمة المعالجة أو سجل المصروف.
Could not save the expense. Retry with the same submission key.|تعذر حفظ المصروف. أعد المحاولة بنفس مفتاح الإرسال.
Could not load expense choices.|تعذر تحميل خيارات المصروف.
Could not load line items.|تعذر تحميل بنود المصروفات.
Why is there no receipt photo?|لماذا لا توجد صورة إيصال؟
Finance photo override|استثناء صورة من الإدارة المالية
The box only has|المتاح في الخزنة فقط
. Ask the office for a top up first.|. اطلب تغذية من الإدارة أولًا.
. You can still save it; Finance will see it.|. يمكنك حفظه وستراجعه الإدارة المالية.
Needs attention|يحتاج إلى معالجة
Cash taken for a purchase|نقدية مسحوبة لشراء
Take cash for a purchase|سحب نقدية لشراء
Take cash|سحب نقدية
Take more|سحب المزيد
Cash taking|سلفة شراء
Purchase takings|سلف الشراء
Cash taken awaiting receipts|نقدية مسحوبة تنتظر إيصالات
Cash taken, no receipt|نقدية مسحوبة بلا إيصال
Cash before the receipt|النقدية قبل الإيصال
Cash still held, counted|النقدية المتبقية المعدودة
Cash came back|عادت النقدية
Cash came back unused|عادت النقدية دون استخدام
Returned unused|مستردة دون استخدام
No receipt yet.|لا يوجد إيصال بعد.
No change or extra|لا يوجد باقي أو مبلغ إضافي
Change|الباقي
Actual spent|المصروف الفعلي
Total spent|إجمالي المصروف
Age from first taking|العمر من أول سحب
The box balance drops now. The named person holds this cash until a receipt or full return closes it.|ينخفض رصيد الخزنة الآن. يبقى المبلغ مع الشخص المحدد حتى تقديم إيصال أو إرجاعه بالكامل.
Purchase order at this branch|أمر شراء لهذا الفرع
Market buy — no PO|شراء من السوق — دون أمر شراء
Choose an open PO — newest first|اختر أمر شراء مفتوحًا — الأحدث أولًا
Search open purchase orders|ابحث في أوامر الشراء المفتوحة
No open purchase orders match your search.|لا توجد أوامر شراء مفتوحة تطابق البحث.
Choose receipt for this PO|اختر إيصالًا لأمر الشراء
Selected receipt|الإيصال المحدد
Add the receipt|إضافة الإيصال
Use the existing supplier receipt and payment. No second supplier payment is created.|استخدم إيصال المورد ودفعة المورد الموجودين. لن تُنشأ دفعة ثانية.
How is the extra settled?|كيف تتم تسوية المبلغ الإضافي؟
Pay extra from the box now|دفع الزيادة من الخزنة الآن
Still owed to the person — show Finance|يبقى مستحقًا للشخص — يُعرض للإدارة المالية
Owed to a person|مستحق لشخص
Owed to people|مستحق للأشخاص
Owed to them|مستحق لهم
Owed to supplier|مستحق للمورد
Open taking|فتح السلفة
Open purchase order|فتح أمر الشراء
Open supplier receipt|فتح إيصال المورد
Open — waiting for the receipt|مفتوح — بانتظار الإيصال
Closed by receipt|مغلق بإيصال
Closed — cash returned unused|مغلق — أُعيدت النقدية دون استخدام
Receipts and settlement history|الإيصالات وسجل التسويات
Reverse settlement|عكس التسوية
Active settlement|تسوية فعالة
Reversed settlement — original evidence retained|تسوية معكوسة — المستندات الأصلية محفوظة
Settlement reversed|عُكست التسوية
Supplier receipt photos|صور إيصال المورد
Loading taking…|جارٍ تحميل السلفة…
Loading takings…|جارٍ تحميل السلف…
Unable to load taking.|تعذر تحميل السلفة.
Unable to load purchase takings.|تعذر تحميل سلف الشراء.
Unable to load people and POs.|تعذر تحميل الأشخاص وأوامر الشراء.
No purchase takings for these branches.|لا توجد سلف شراء لهذه الفروع.
In transit|قيد النقل
Preparation|تجهيز
Preparation — cash not handed over|تجهيز — لم تُسلّم النقدية
Handover|تسليم النقدية
Handed over|تم التسليم
Hand cash to the office|تسليم نقدية للإدارة
Collection|تحصيل
Collector|المحصّل
Registered collector|محصّل مسجل
Choose collector|اختر المحصّل
Choose a collector|اختر محصّلًا
Type a name — signed slip required|أدخل اسمًا — يلزم إيصال موقّع
Collector's full name|اسم المحصّل بالكامل
Collector confirms with their PIN|يؤكد المحصّل برقمه السري
Collector PIN or signed slip; in transit until counted|رقم المحصّل السري أو إيصال موقّع؛ تبقى قيد النقل حتى الجرد
Ask the collector to enter their own PIN on this phone. Five wrong tries lock it for 15 minutes.|اطلب من المحصّل إدخال رقمه السري على هذا الهاتف. خمس محاولات خاطئة توقفه 15 دقيقة.
Cash leaves the box only after the collector confirms their PIN or the signed slip is uploaded. It stays in transit until the office counts it.|تخرج النقدية من الخزنة بعد تأكيد الرقم السري للمحصّل أو رفع الإيصال الموقّع فقط. وتبقى قيد النقل حتى تجردها الإدارة.
Upload a photo of the signed slip before handing over cash.|ارفع صورة الإيصال الموقّع قبل تسليم النقدية.
Signed slip uploaded|رُفع الإيصال الموقّع
Signed slip selected — will upload before handover|اختير الإيصال الموقّع — سيُرفع قبل التسليم
Receive collections|استلام التحصيلات
Receive selected handovers|استلام التسليمات المحددة
Confirm office count|تأكيد جرد الإدارة
Total counted at the office|إجمالي المعدود في الإدارة
Office count:|جرد الإدارة:
Reason if short or over|السبب عند وجود عجز أو زيادة
Resolve collection difference|معالجة فرق التحصيل
Resolve difference|معالجة الفرق
Resolved|تمت المعالجة
Reverse office count|عكس جرد الإدارة
Reverse this count|عكس هذا الجرد
Open handover entry and proof|فتح قيد التسليم وإثباته
Collectors — finance manages this list|المحصّلون — تدير الإدارة المالية هذه القائمة
Add collector|إضافة محصّل
Activate|تفعيل
Deactivate|إيقاف
Inactive|غير فعال
Unable to load collectors or users.|تعذر تحميل المحصّلين أو المستخدمين.
Unable to load collectors.|تعذر تحميل المحصّلين.
Unable to complete collection request|تعذر إتمام طلب التحصيل
The collection could not be prepared.|تعذر تجهيز التحصيل.
Loading collections…|جارٍ تحميل التحصيلات…
No collections match these filters.|لا توجد تحصيلات تطابق المرشحات.
Cash handed to the office. Count each collection separately, or count selected handovers together with one total per branch and collector. A group difference is never allocated arbitrarily between handovers.|النقدية المسلّمة للإدارة. اجرد كل تحصيل منفردًا، أو اجرد التسليمات المحددة بإجمالي واحد لكل فرع ومحصّل. لا يُوزع فرق المجموعة افتراضيًا على التسليمات.
My confirmation PIN|رقمي السري للتأكيد
Current PIN (when already set)|الرقم السري الحالي (إن سبق تعيينه)
New PIN|الرقم السري الجديد
Confirm new PIN|تأكيد الرقم السري الجديد
Save my PIN|حفظ رقمي السري
PIN|الرقم السري
PINs do not match.|الرقمان السريان غير متطابقين.
Your PIN has been saved.|تم حفظ رقمك السري.
Loading PIN settings…|جارٍ تحميل إعدادات الرقم السري…
Five wrong attempts lock your PIN for 15 minutes.|خمس محاولات خاطئة توقف الرقم السري لمدة 15 دقيقة.
You need an active membership in this workspace to set your confirmation PIN.|تحتاج إلى عضوية فعالة في مساحة العمل لتعيين رقم التأكيد السري.
Your own 4–6 digit PIN confirms cash handovers and acceptance of your personal floats. Collector membership is not required to set your PIN. Five incorrect attempts lock it for 15 minutes. Never share it.|رقمك السري الشخصي المكوّن من 4–6 أرقام يؤكد تسليم النقدية وقبول عهدك الشخصية. لا يلزم أن تكون محصّلًا لتعيينه. خمس محاولات خاطئة توقفه 15 دقيقة. لا تشاركه مع أي شخص.
My profile|ملفي الشخصي
Count the box|جرد الخزنة
Save count|حفظ الجرد
Should have|المفترض وجوده
Counted at|وقت الجرد
Counted by|القائم بالجرد
Counted by:|القائم بالجرد:
Counted with|شاهد الجرد
Last counted|آخر جرد
Last counts|آخر عمليات الجرد
Count record|سجل الجرد
Ledger sequence at count|تسلسل الدفتر عند الجرد
Reason for difference|سبب الفرق
Choose reason|اختر السبب
Change error|خطأ في الباقي
Missing entry, entered now|قيد ناقص، سُجل الآن
Other|أخرى
Choose a reason; Other requires a note.|اختر سببًا؛ «أخرى» تتطلب ملاحظة.
Who counted with you is required.|يجب تحديد من شهد الجرد معك.
Book cash − counted cash = difference:|نقدية الدفتر − النقدية المعدودة = الفرق:
Expected amount is the recorded balance at counting time. Later entries may change the day’s totals.|المبلغ المتوقع هو الرصيد المسجل وقت الجرد. قد تغير القيود اللاحقة إجماليات اليوم.
Since the last count (or opening), by posting sequence. The last count adjustment is excluded.|منذ آخر جرد (أو افتتاح)، وفق ترتيب الترحيل. يُستبعد تعديل الجرد الأخير.
This box has already been counted today.|جُردت هذه الخزنة اليوم بالفعل.
Record not found in the selected branches.|السجل غير موجود في الفروع المحددة.
Record not found in this workspace.|السجل غير موجود في مساحة العمل.
Start a job|بدء عمل
Start job|بدء العمل
What is the job?|ما العمل؟
Agreed amount|المبلغ المتفق عليه
Expected total|الإجمالي المتوقع
Quote photo (optional)|صورة عرض السعر (اختيارية)
Payment receipt photo (required)|صورة إيصال الدفع (مطلوبة)
Final invoice photo (required)|صورة الفاتورة النهائية (مطلوبة)
Final invoice|الفاتورة النهائية
Final invoice total|إجمالي الفاتورة النهائية
Final invoice recorded|سُجلت الفاتورة النهائية
Record final invoice|تسجيل الفاتورة النهائية
Finish the job|إنهاء العمل
Pay toward a job|دفع مقابل عمل
Pay toward this job|دفع مقابل هذا العمل
Payment amount|مبلغ الدفعة
Record payment|تسجيل دفعة
Payments (net of reversals)|الدفعات (صافي العكس)
Payment evidence|مستند الدفعة
Job evidence|مستندات العمل
Job creation returned no job ID.|لم تُرجع عملية إنشاء العمل معرّفًا.
Could not save the job.|تعذر حفظ العمل.
Could not load jobs.|تعذر تحميل الأعمال.
Could not load job.|تعذر تحميل العمل.
Loading jobs…|جارٍ تحميل الأعمال…
Loading job…|جارٍ تحميل العمل…
All jobs|جميع الأعمال
No jobs in this selection.|لا توجد أعمال ضمن هذا الاختيار.
Jobs needing attention|أعمال تحتاج إلى معالجة
Open more than 30 days ·|مفتوح منذ أكثر من 30 يومًا ·
In progress|قيد التنفيذ
Finished|منتهٍ
Overpaid — needs attention|المدفوع زائد — يحتاج إلى معالجة
Unpaid final amounts stay open as Owed to supplier.|تبقى المبالغ النهائية غير المدفوعة مفتوحة كمستحق للمورد.
Explain why the job is overpaid.|وضّح سبب دفع مبلغ زائد للعمل.
This is above the expected total or below the amount already paid. A reason is required.|المبلغ أعلى من المتوقع أو أقل من المدفوع بالفعل. يلزم ذكر السبب.
Expected is the original agreement; remaining is expected (or final invoice total) minus signed payments below.|المتوقع هو الاتفاق الأصلي؛ والمتبقي هو المتوقع (أو إجمالي الفاتورة النهائية) ناقص الدفعات أدناه بإشارتها.
Correct the final invoice|تصحيح الفاتورة النهائية
Reverse completion|عكس إتمام العمل
Completion reversed|عُكس إتمام العمل
Reverse this completion before recording a corrected final invoice. Payments and the original invoice remain in history.|اعكس هذا الإتمام قبل تسجيل الفاتورة النهائية المصححة. تبقى الدفعات والفاتورة الأصلية في السجل.
Whole job; click for all payments, including reversals|العمل بالكامل؛ اضغط لعرض كل الدفعات بما فيها العكس
Accept my float|قبول عهدتي
Give a float|تسليم عهدة
Registered recipient|المستلم المسجل
Funding source|مصدر التمويل
Return destination|وجهة الإرجاع
Pending acceptance|بانتظار القبول
Pending allocation|تخصيص لم يُقبل بعد
Accepted held|النقدية المقبولة المحتفظ بها
Accepted float held|العهد المقبولة المحتفظ بها
All floats|جميع العهد
No personal floats in this selection.|لا توجد عهد شخصية ضمن هذا الاختيار.
Loading floats…|جارٍ تحميل العهد…
Loading float…|جارٍ تحميل العهدة…
Personal floats needing attention|عهد شخصية تحتاج إلى معالجة
Pending acceptance more than 24 hours|بانتظار القبول منذ أكثر من 24 ساعة
No approved settlement in 14 days|لا توجد تسوية معتمدة منذ 14 يومًا
Settlement waiting for finance|تسوية تنتظر الإدارة المالية
Counted cash difference needs review|فرق النقدية المعدودة يحتاج إلى مراجعة
Accept, spend and settle your own company cash.|اقبل عهدة الشركة الخاصة بك، واصرف منها وسوّها.
Confirm only after receiving this cash. Acceptance does not deduct the branch box again.|أكد فقط بعد استلام النقدية. القبول لا يخصم من خزنة الفرع مرة ثانية.
Pending allocations are not spendable. Accepted floats can be spent only by their named recipient.|لا يمكن الصرف من تخصيص لم يُقبل. العهد المقبولة يصرف منها المستلم المحدد فقط.
Spend from my float|الصرف من عهدتي
This expense exceeds the cash held in your float.|هذا المصروف يتجاوز النقدية المتاحة في عهدتك.
Submission pauses new spending until finance reviews it.|الإرسال يوقف الصرف الجديد حتى مراجعة الإدارة المالية.
Submit settlement|إرسال التسوية
Settlement|تسوية
In review|قيد المراجعة
In review — spending is paused.|قيد المراجعة — الصرف موقوف.
Review settlement|مراجعة التسوية
Decision|القرار
Approve|اعتماد
Reject and return to recipient|رفض وإعادة إلى المستلم
Review reason|سبب المراجعة
Restore agreed float|استكمال العهدة المتفق عليها
Close and return counted cash|إغلاق وإرجاع النقدية المعدودة
Return actual counted cash only. Approval does not create money to cover a shortage.|أعد النقدية المعدودة فعليًا فقط. الاعتماد لا ينشئ نقدية لتغطية العجز.
Explain the counted cash difference.|وضّح فرق النقدية المعدودة.
Should hold|المفترض معه
After approval|بعد الاعتماد
Agreed|المتفق عليه
Full float history|السجل الكامل للعهدة
Funding and expenses explain held cash. Settlement counts and approvals are retained evidence, not additional funding.|التمويل والمصروفات يفسران النقدية المتبقية. تُحفظ أعداد التسوية واعتماداتها كمستندات وليست تمويلًا إضافيًا.
The submitted values are retained for a safe retry. Close and refresh the record before starting a different action.|تُحفظ القيم المرسلة لإعادة المحاولة بأمان. أغلق السجل وحدّثه قبل بدء إجراء مختلف.
Open linked box entry|فتح قيد الخزنة المرتبط
Open personal float|فتح العهدة الشخصية
Active|فعال
Closed|مغلق
Oldest open item|أقدم بند مفتوح
Taken|المسحوب
Total held|إجمالي المحتفظ به
Total held is company cash awaiting receipts plus accepted floats. Money owed to a person is shown separately, not subtracted. Pending allocations have not yet been accepted.|الإجمالي هو نقدية الشركة المنتظرة للإيصالات مع العهد المقبولة. تظهر المستحقات للأشخاص منفصلة ولا تُخصم. التخصيصات المعلقة لم تُقبل بعد.
No open cash held or owed in these branches.|لا توجد نقدية محتفظ بها أو مستحقات مفتوحة في هذه الفروع.
Could not load cash holders.|تعذر تحميل حاملي النقدية.
Loading cash holders…|جارٍ تحميل حاملي النقدية…
No cash held by people.|لا توجد نقدية مع أشخاص.
Outside the box, not additional box cash|خارج الخزنة، وليست نقدية إضافية فيها
Held by people|نقدية مع الأشخاص
Still held by people|لا تزال مع الأشخاص
Stock bought with cash|مخزون اشتُري نقدًا
Stock spending|الصرف على المخزون
Stock|المخزون
Spent in period|المصروف خلال الفترة
Spent in the period|المصروف خلال الفترة
Held at period end|المتبقي مع الأشخاص في نهاية الفترة
Total spent from boxes|إجمالي المصروف من الخزن
Expense total|إجمالي المصروفات
Expenses|المصروفات
Expenses by category and line item|المصروفات حسب الفئة والبند
Stock bought with cash, by supplier or shop|مخزون اشتُري نقدًا حسب المورد أو المحل
Items bought with cash|أصناف اشتُريت نقدًا
Receipt count|عدد الإيصالات
Receipts|الإيصالات
Distinct receipts|إيصالات غير مكررة
Receipt-line total|إجمالي بنود الإيصال
Receipt-line value|قيمة بنود الإيصال
Share of stock|حصة المخزون
Quantity|الكمية
Average unit price|متوسط سعر الوحدة
Weighted average unit price|متوسط سعر الوحدة المرجح
Branch · item · unit|الفرع · الصنف · الوحدة
Now is live; spending and count differences use the selected dates.|الأرصدة الحالية مباشرة؛ الصرف وفروق الجرد حسب التواريخ المحددة.
Loading report…|جارٍ تحميل التقرير…
Unable to load report|تعذر تحميل التقرير
Open current receipt lines for|فتح بنود الإيصال الحالية لـ
Open original receipt attachment|فتح مرفق الإيصال الأصلي
Image preview unavailable. Open the original attachment above (it may be a PDF).|معاينة الصورة غير متاحة. افتح المرفق الأصلي أعلاه (قد يكون ملف مستند).
Confirmed supplier receipt|إيصال مورد مؤكد
Supplier receipt|إيصال المورد
Linked entry|القيد المرتبط
Last purchase|آخر شراء
Distinct receipt IDs; reversal entries retain their source receipt.|معرّفات إيصالات غير مكررة؛ قيود العكس تحتفظ بإيصالها الأصلي.
Count distinct receipt IDs in these lines.|عدّ معرّفات الإيصالات غير المكررة في هذه البنود.
Sum of all matching evidence contributions.|مجموع مساهمات المستندات المطابقة.
Sum of signed quantities in this unit and branch only.|مجموع الكميات بإشارتها لهذه الوحدة وهذا الفرع فقط.
Maximum signed event contribution, not the evidence sum; all tied entries are shown.|أكبر مساهمة حدث بإشارته، وليس مجموع المستندات؛ تُعرض كل القيود المتساوية.
EGP spending evidence. This is not a reconstruction of the original lines.|مستند صرف بالجنيه المصري. ليس إعادة إنشاء للبنود الأصلية.
— Current document only, excluded from historical item analytics because its lines do not reconcile to the immutable|— المستند الحالي فقط، مستبعد من التحليل التاريخي للأصناف لأن بنوده لا تتطابق مع القيمة الثابتة
Category|الفئة
Category name|اسم الفئة
Category code|كود الفئة
Category unavailable|الفئة غير متاحة
Branch unavailable|الفرع غير متاح
Line item|بند المصروف
Expense line item|بند المصروف
Line items|بنود المصروفات
Line item name|اسم بند المصروف
Line item name in English|اسم بند المصروف بالإنجليزية
Line item name in Arabic|اسم بند المصروف بالعربية
Item|البند
Items|البنود
Item code|كود البند
All categories|جميع الفئات
All line items|جميع البنود
Choose a category|اختر فئة
Choose a category from the list.|اختر فئة من القائمة.
Select a category|اختر فئة
Choose a line item|اختر بندًا
Choose a line item.|اختر بندًا.
No line items yet.|لا توجد بنود بعد.
Name in Arabic|الاسم بالعربية
Name in English|الاسم بالإنجليزية
Accounting code|الكود المحاسبي
No changes recorded yet.|لا توجد تغييرات مسجلة بعد.
Permanent record and history|السجل الدائم والتاريخ
Complete history|السجل الكامل
History|السجل
Change log|سجل التغييرات
What changed|ما الذي تغير
Both English and Arabic names are required.|الاسمان بالإنجليزية والعربية مطلوبان.
Fill in both names.|أدخل الاسمين.
Fill in both category names.|أدخل اسمي الفئة.
Check names and code.|راجع الاسمين والكود.
Check the code.|راجع الكود.
Check this line item.|راجع بند المصروف.
Code is available|الكود متاح
Checking names and code…|جارٍ مراجعة الاسمين والكود…
Checking…|جارٍ المراجعة…
Could not check this value.|تعذر مراجعة هذه القيمة.
Check failed.|تعذرت المراجعة.
It's a different thing|هذا بند مختلف
. It's a different thing?|. هل هذا بند مختلف؟
Similar name: tick “It's a different thing” to continue.|اسم مشابه: حدد «هذا بند مختلف» للمتابعة.
Similar name. Press Enter again or Add anyway if it's a different thing.|اسم مشابه. اضغط الإدخال مجددًا أو «إضافة رغم ذلك» إن كان بندًا مختلفًا.
Review similar names and tick “It's a different thing” before creating.|راجع الأسماء المشابهة وحدد «هذا بند مختلف» قبل الإنشاء.
Same name twice in this category.|الاسم مكرر في هذه الفئة.
Fix the line items marked in red.|صحح البنود المحددة بالأحمر.
Add anyway|إضافة رغم ذلك
Add|إضافة
Edit|تعديل
Add a line item|إضافة بند مصروف
+ Another line item|+ بند آخر
Create category|إنشاء فئة
New category|فئة جديدة
New category →|فئة جديدة ←
Add a category manually|إضافة فئة يدويًا
Category created. IDs and codes are reserved permanently.|أُنشئت الفئة. المعرّفات والأكواد محجوزة دائمًا.
Line item added. The code and ID are now reserved.|أُضيف البند. الكود والمعرّف محجوزان الآن.
Could not add line item. Check and try again.|تعذر إضافة البند. راجع البيانات وحاول مرة أخرى.
Could not create category. Please retry.|تعذر إنشاء الفئة. أعد المحاولة.
Changes saved and logged.|حُفظت التغييرات وسُجلت.
Could not save. Please retry.|تعذر الحفظ. أعد المحاولة.
Could not save. Please try again.|تعذر الحفظ. حاول مرة أخرى.
Archive|أرشفة
Archived|مؤرشف
Reason for archiving *|سبب الأرشفة *
Give a reason for archiving.|اذكر سبب الأرشفة.
Hidden from branches. Its ID and code stay reserved.|مخفي عن الفروع. يظل المعرّف والكود محجوزين.
The ID never changes. Changes are recorded in the log.|المعرّف لا يتغير. تُحفظ التغييرات في السجل.
This category's code is locked because it has line items, including archived items.|كود هذه الفئة مقفل لوجود بنود بها، بما فيها المؤرشفة.
Every change, newest first. IDs and accounting codes are never reused.|كل تغيير، الأحدث أولًا. لا يُعاد استخدام المعرّفات أو الأكواد المحاسبية.
Default usual up to|الحد المعتاد الافتراضي
Usual up to|الحد المعتاد
Usual up to (EGP)|الحد المعتاد (ج.م.)
Usual amount, up to (EGP)|المبلغ المعتاد حتى (ج.م.)
Usual amounts|المبالغ المعتادة
Requires note|يتطلب ملاحظة
Branch amounts|مبالغ الفروع
Use default|استخدم الافتراضي
All branches use the default|جميع الفروع تستخدم الافتراضي
Return to categories|العودة إلى الفئات
‹ All categories|‹ جميع الفئات
What branches will see|ما ستراه الفروع
This is the tile they tap when they record an expense.|هذه البطاقة التي يختارها الفرع عند تسجيل المصروف.
Set up your expense categories|إعداد فئات المصروفات
Start from a spreadsheet or add your first category by hand. Branches will use this list when recording cash expenses.|ابدأ بجدول بيانات أو أضف أول فئة يدويًا. ستستخدم الفروع هذه القائمة عند تسجيل المصروفات النقدية.
Branches pick from this list when they record a cash expense.|تختار الفروع من هذه القائمة عند تسجيل مصروف نقدي.
Finance adds and changes these. Missing one? Use “It's not in the list” when you record the expense.|تضيف الإدارة المالية هذه البنود وتعدلها. إذا لم تجد بندًا، اختر «غير موجود بالقائمة» عند تسجيل المصروف.
Best for a short list. Add bilingual names, line items and limits one at a time.|مناسب لقائمة قصيرة. أضف الأسماء باللغتين والبنود والحدود واحدًا تلو الآخر.
Find a category, line item or code|ابحث عن فئة أو بند أو كود
Nothing matches your search.|لا توجد نتائج تطابق البحث.
Loading categories…|جارٍ تحميل الفئات…
Loading line items…|جارٍ تحميل البنود…
Could not load expense setup|تعذر تحميل إعداد المصروفات
Could not load history.|تعذر تحميل السجل.
Last top up|آخر تغذية
No top up recorded|لا توجد تغذية مسجلة
New float|عهدة جديدة
Save float|حفظ العهدة
Change the float|تغيير العهدة
Change the float ·|تغيير العهدة ·
Float changed|تغيرت العهدة
No float changes recorded.|لا توجد تغييرات مسجلة للعهدة.
Cash boxes is available to Finance and administrators only.|إدارة الخزن متاحة للإدارة المالية ومسؤولي النظام فقط.
Utilities|المرافق
Water bill|فاتورة المياه
Gas cylinder|أسطوانة الغاز
Gas, transport, repairs, cleaning|غاز، نقل، إصلاحات، نظافة
Gas, taxi, سباكة, 6301…|غاز، مواصلات، سباكة، 6301…
e.g. Marketing|مثل: التسويق
Received|مستلم
Missing|ناقص
Day not counted|يوم لم يُجرد
Export to Excel|تصدير إلى إكسل
Export failed|تعذر التصدير
Download current list|تنزيل القائمة الحالية
Download empty template|تنزيل نموذج فارغ
Upload spreadsheet|رفع جدول بيانات
Upload spreadsheet →|رفع جدول بيانات ←
Fill the Excel template &amp; upload|املأ نموذج إكسل وارفعه
Fill the Excel template & upload|املأ نموذج إكسل وارفعه
Template|النموذج
Spreadsheet file|ملف جدول البيانات
Spreadsheet template preview|معاينة نموذج جدول البيانات
1. Start with the template|1. ابدأ بالنموذج
2. Upload your file|2. ارفع الملف
3. Review before import|3. راجع قبل الاستيراد
Seven columns. One row per line item; repeat the category on every row.|سبعة أعمدة. صف لكل بند؛ كرر الفئة في كل صف.
No ID column: Infrastock assigns permanent IDs at import.|لا يوجد عمود معرّف: يعيّن إنفراستوك المعرّفات الدائمة عند الاستيراد.
Download the seven-column template, fill it in Excel, upload and check every row before saving. Codes can be generated for you.|نزّل نموذج الأعمدة السبعة واملأه في إكسل وارفعه، ثم راجع كل صف قبل الحفظ. يمكن توليد الأكواد لك.
Build your category list in Excel, then check it before anything is saved.|أنشئ قائمة الفئات في إكسل ثم راجعها قبل حفظ أي شيء.
Continue to upload|المتابعة إلى الرفع
Back to upload|العودة إلى الرفع
Drop a spreadsheet here or choose a file|اسحب جدول البيانات هنا أو اختر ملفًا
Choose spreadsheet|اختر جدول بيانات
.csv or .xlsx · Nothing is imported yet|ملف .csv أو .xlsx · لم يُستورد شيء بعد
CSV or XLSX. Check the seven column names before uploading.|ملف .csv أو .xlsx. راجع أسماء الأعمدة السبعة قبل الرفع.
Leave usual_up_to blank for no limit; otherwise use a nonnegative amount.|اترك عمود usual_up_to فارغًا لعدم وضع حد، أو أدخل مبلغًا غير سالب.
Codes are optional. Infrastock can generate unused four-digit codes.|الأكواد اختيارية. يمكن لإنفراستوك توليد أكواد غير مستخدمة من أربعة أرقام.
Empty code handling|التعامل مع الأكواد الفارغة
Autogenerate|توليد تلقائي
Treat as errors|اعتبارها أخطاء
Check rows|مراجعة الصفوف
Checking file…|جارٍ مراجعة الملف…
Checking full file|جارٍ مراجعة الملف بالكامل
Could not read this file.|تعذر قراءة هذا الملف.
Could not check rows. Please retry.|تعذر مراجعة الصفوف. أعد المحاولة.
Both English and Arabic names are required. Leave all item fields blank for a category-only row.|الاسمان بالإنجليزية والعربية مطلوبان. اترك حقول البند فارغة لصف الفئة فقط.
Preview counts|أعداد المعاينة
Row|الصف
Result|النتيجة
Gets ID|سيحصل على معرّف
New · will import|جديد · سيُستورد
Skip · already exists|تخطي · موجود بالفعل
Check · similar, will import|مراجعة · مشابه، سيُستورد
Error · won't import|خطأ · لن يُستورد
New record. Name and code checks passed; ready to import.|سجل جديد. اجتاز الاسمان والكود المراجعة؛ جاهز للاستيراد.
Existing and archived categories and items are checked, not recreated.|تُراجع الفئات والبنود الموجودة والمؤرشفة ولا يُعاد إنشاؤها.
Show only rows to check (Check and Error)|عرض الصفوف التي تحتاج إلى مراجعة فقط (مراجعة وخطأ)
No Check or Error rows. Show all rows to see the full preview.|لا توجد صفوف تحتاج إلى مراجعة أو بها أخطاء. اعرض الكل لرؤية المعاينة الكاملة.
Download rows to fix (|تنزيل الصفوف المطلوب تصحيحها (
Download the rows to fix (|تنزيل الصفوف المطلوب تصحيحها (
Replace file|استبدال الملف
Importing…|جارٍ الاستيراد…
Import complete|اكتمل الاستيراد
Import failed. Nothing was saved; please retry.|تعذر الاستيراد. لم يُحفظ شيء؛ أعد المحاولة.
The catalog changed since your check. Check this file again before importing.|تغير الدليل منذ المراجعة. راجع الملف مرة أخرى قبل الاستيراد.
IDs and accounting codes are reserved permanently. Every change is recorded with this upload number.|المعرّفات والأكواد المحاسبية محجوزة دائمًا. كل تغيير مسجل برقم هذا الرفع.
codes generated in this preview. Matching existing categories keep their code.|أكواد مولدة في المعاينة. تحتفظ الفئات المطابقة الموجودة بأكوادها.
· Nothing has been saved. Check rows will import; Skip and Error rows will not.|· لم يُحفظ شيء. ستُستورد صفوف المراجعة، ولن تُستورد صفوف التخطي والأخطاء.
Usual amounts from what branches spend|المبالغ المعتادة حسب صرف الفروع
Loading suggestions…|جارٍ تحميل الاقتراحات…
Could not load suggestions.|تعذر تحميل الاقتراحات.
Suggest|اقتراح
Suggested|المقترح
Based on|بناءً على
The average|المتوسط
The highest|الأعلى
Average|المتوسط
Highest|الأعلى
Average + 15%|المتوسط + 15%
Average + 30%|المتوسط + 30%
Highest expense|أعلى مصروف
Only entries with a photo|القيود التي بها صورة فقط
Leave out unusually big ones|استبعاد المبالغ الكبيرة غير المعتادة
Use|استخدام
Use all suggestions|استخدام جميع الاقتراحات
No category code blocks available after the highest code.|لا توجد مجموعات أكواد فئات متاحة بعد أعلى كود.
Code block|مجموعة الأكواد
Press Enter to add · Next ID|اضغط الإدخال للإضافة · المعرّف التالي
Next ID|المعرّف التالي
Current branch-specific limits, or current default. Not historical evidence.|حدود الفرع الحالية أو الحد الافتراضي الحالي، وليست مستندًا تاريخيًا.
Empty branch amounts use the default. No limit is an explicit exception. Rows without entries have no suggestion and are left unchanged.|المبالغ الفارغة تستخدم الافتراضي. «بلا حد» استثناء صريح. الصفوف دون قيود لا تحصل على اقتراح وتبقى دون تغيير.
This list totals the filtered cash movements. Each purchase appears once, at its newest matching entry. Blocks show whole-purchase spending, not an additional cash deduction; click to see all linked evidence.|تجمع هذه القائمة الحركات النقدية المرشحة. يظهر كل شراء مرة عند أحدث قيد مطابق. تعرض المجموعات صرف الشراء بالكامل، لا خصمًا إضافيًا؛ اضغط لعرض المستندات المرتبطة.
Only posted entries contribute to cash totals. Pending entries retain the original list filters and contribute zero. Box balances use posting order, include entries outside these dates and filters, and are not period-calculation subtotals.|تدخل القيود المرحلة فقط في الإجماليات النقدية. تحتفظ القيود المعلقة بالمرشحات وتساهم بصفر. أرصدة الخزن وفق ترتيب الترحيل وتشمل قيودًا خارج التواريخ والمرشحات، وليست إجماليات فرعية للفترة.
Posting order · not a period subtotal|ترتيب الترحيل · ليس إجماليًا فرعيًا للفترة
This branch’s own balance in posting order, including entries outside the filters|رصيد هذا الفرع بترتيب الترحيل، ويشمل قيودًا خارج المرشحات
Opening + Money in − Money out ± Count differences = Closing|الافتتاحي + النقدية الداخلة − النقدية الخارجة ± فروق الجرد = الختامي
Configured opening balances — not ledger entries|أرصدة افتتاحية مضبوطة — ليست قيودًا بالدفتر
Configured opening (EGP)|الافتتاحي المضبوط (ج.م.)
Box opened after the range ended|فُتحت الخزنة بعد نهاية الفترة
Period balance = configured opening contributions + signed posted movements across all evidence pages. A box opened during the selected range contributes its opening amount to Opening. Boxes with no movements still contribute their configured opening.|رصيد الفترة = مساهمات الافتتاحي المضبوطة + الحركات المرحلة بإشارتها في جميع صفحات المستندات. الخزنة المفتوحة خلال الفترة تساهم بمبلغ افتتاحها. وتساهم الخزن دون حركات بأرصدة افتتاحها.
Does not match balance now — refresh to check for new or future-dated entries.|لا يطابق الرصيد الحالي — حدّث للتحقق من قيود جديدة أو مستقبلية.
Always live · unaffected by dates and filters|مباشر دائمًا · لا يتأثر بالتواريخ أو المرشحات
In all boxes|في جميع الخزن
Top up needed = float − in the box. A negative gap means the box is above its float; no top up is needed.|التغذية المطلوبة = العهدة المستهدفة − المتاح بالخزنة. الفرق السالب يعني تجاوز الرصيد للعهدة، فلا تلزم تغذية.
Gap|الفجوة
After newest matching entry|بعد أحدث قيد مطابق
Since|منذ
Additional cash (EGP)|نقدية إضافية (ج.م.)
Stock bought with cash, by supplier or shop|المخزون المشترى نقدًا حسب المورد أو المحل
Receipt quantities and full line values, grouped separately by item, saved unit label and branch. Average is the weighted receipt-line value per unit, not the original four-decimal purchase rate (shown in detail). Part-funded receipts include the owed portion here; these values are not added to cash spending. The receipt schema stores a unit label, not a historical unit ID.|كميات الإيصالات وقيم البنود الكاملة، مجمعة حسب الصنف واسم الوحدة المحفوظ والفرع. المتوسط هو قيمة بنود الإيصال المرجحة للوحدة، وليس سعر الشراء الأصلي بأربع منازل (المعروض بالتفاصيل). تشمل الإيصالات الممولة جزئيًا الجزء المستحق هنا؛ ولا تضاف هذه القيم إلى الصرف النقدي. يُحفظ اسم الوحدة وليس معرّف وحدة تاريخي.
EGP. Spending is recognised on the movement’s Cairo date, or the receipt settlement’s Cairo date for takings. Advances and change are not counted again. Amounts owed to people are excluded from box-funded spending. Held is the balance at the end of the selected range, not additional spending. Count differences are separate signed adjustments. Historical supplier payments without box evidence are excluded.|بالجنيه المصري. يُحتسب الصرف بتاريخ الحركة بتوقيت القاهرة، أو بتاريخ تسوية الإيصال للسلف. لا تُحسب الدفعات المقدمة والباقي مرة أخرى. تُستبعد المستحقات للأشخاص من الصرف الممول من الخزنة. المحتفظ به هو الرصيد بنهاية الفترة وليس صرفًا إضافيًا. فروق الجرد تعديلات مستقلة بإشارتها. تُستبعد دفعات الموردين التاريخية التي ليس لها مستند خزنة.
Posted, non-reversed expenses only, by Cairo expense date. All branches pools entries in your permitted branches. Unusually big means more than twice each row's 75th percentile, after the photo filter. Suggestions round up to 10 EGP; only the written amounts are checked and saved.|المصروفات المرحلة غير المعكوسة فقط بتاريخ القاهرة. يجمع خيار «جميع الفروع» قيود الفروع المصرح بها. المبالغ غير المعتادة تتجاوز ضعف المئين 75 لكل صف بعد مرشح الصور. تُقرب الاقتراحات لأعلى إلى 10 جنيهات؛ تُراجع وتُحفظ المبالغ المكتوبة فقط.
IDs are given by Infrastock from a counter that only goes up, so they never repeat. Codes must be unique, including archived lines. Click an ID for its history.|يعيّن إنفراستوك المعرّفات من عدّاد متزايد، فلا تتكرر. يجب أن تكون الأكواد فريدة، بما فيها البنود المؤرشفة. اضغط المعرّف لعرض سجله.
rows. Snapshot values are retained while this list is open.|صفوف. تُحفظ قيم اللقطة ما دامت القائمة مفتوحة.
· Whole purchase; click for all linked entries and receipt|· الشراء بالكامل؛ اضغط لعرض القيود والإيصال المرتبطين
· Usual limits are current settings, not historical limits.|· الحدود المعتادة إعدادات حالية وليست حدودًا تاريخية.
· Counted with:|· شاهد الجرد:
· Agreed float|· العهدة المتفق عليها
· First taken|· أول سحب
· Pending allocation|· تخصيص لم يُقبل بعد
Receipt|إيصال
Expense receipt|إيصال المصروف
No|لا
OK|موافق
Retry photo|إعادة رفع الصورة
Upload|رفع
Upload progress|تقدم الرفع
Enter|إدخال
Group by|تجميع حسب
By branch|حسب الفرع
First taken|أول سحب
Last receipt|آخر إيصال
Payment|دفعة
Return|إرجاع
Accept|قبول
Reject|رفض
Give|تسليم
Spend|صرف
Approve|اعتماد
Topup|تغذية
Surplus return|إرجاع الزيادة
Branch box|خزنة الفرع
Give|تسليم
Accept|قبول
Spend|صرف
Settle|تسوية
Approve|اعتماد
Reject|رفض
Topup|تغذية
Surplus|زيادة
Back|إرجاع
Reversal|عكس
active|فعال
pending|معلق
closed|مغلق
give|تسليم
accept|قبول
spend|صرف
settlement|تسوية
approve|اعتماد
reject|رفض
topup|تغذية
surplus return|إرجاع الزيادة
return|إرجاع
reversal|عكس
branch box|خزنة الفرع
safe|الخزنة المركزية
bank|البنك
wallet|المحفظة
expense|مصروف
purchase|شراء
advance|دفعة مقدمة
count diff|فرق جرد
handover|تسليم
taken|سحب
back|إرجاع
extra|إضافي
float out|تسليم عهدة
float back|إرجاع عهدة
photo|صورة
classified|مصنف
error|خطأ
Jan|يناير
Feb|فبراير
Mar|مارس
Apr|أبريل
May|مايو
Jun|يونيو
Jul|يوليو
Aug|أغسطس
Sep|سبتمبر
Oct|أكتوبر
Nov|نوفمبر
Dec|ديسمبر
`.trim().split("\n").map(line => { const split = line.indexOf("|"); return [line.slice(0, split), line.slice(split + 1)]; }));